import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const PermissionSets = lazy(() => import("@scenes/PermissionSettings/components/PermissionSets"));

export const permissionSettingsPermissionSetsNRO: NavigationRoutingObject = {
  Component: PermissionSets,
  componentFeatureFlippers: [],
  noKnockoutFallback: true,
  section: "settings",
  heading: (t: I18nT<"dashboard-navigation">) => t("permission-sets-nro-heading", "Permission Sets"),
  pageNameForTracking: () => "Permission Sets",
  getDeveloperNavigationAllowed: () => true,
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
  defaultRoute: "/company_settings/user_management/permission_sets/:appGroupId",
};
